<bringoz-icon *ngIf="type"
              [iconName]="type | lowercase"
              [ngbTooltip]="tooltip"
              container="body"
              openDelay="300"
              triggers="hover">
</bringoz-icon>

<ng-template #tooltip>
  <span class="br-body-2">{{type | translate}}</span>
</ng-template>
